// extracted by mini-css-extract-plugin
export var arrow = "hD_dQ";
export var container = "hD_c";
export var contentWrapper = "hD_qz";
export var description = "hD_p";
export var descriptionLink = "hD_qB";
export var image = "hD_d9";
export var innerContainer = "hD_fh";
export var link = "hD_b2";
export var text = "hD_dh";
export var title = "hD_h";